import PerTypes from 'store/actionTypes/per'
import UserTypes from 'store/actionTypes/user'

const initialData = {
  list: [],
  systems: [],
  current: {},
  pagination: {},
  filter: {},
  currentData: {},
  alert: {
    list: [],
    pagination: {}
  },
  packageLog: {
    list: [],
    pagination: {}
  },
  vehicleTrip: {
    list: [],
    pagination: {},
    current: {},
    exportData: {}
  },
  companyPersLinked: [],
  persKitConfiguration: {},
  mqttMessageLog: {
    list: [],
    pagination: {}
  },
  downloadableFirmwareVersions: [],
  downloadableKitConfigurationVersions: [],
  downloadableKitConfigurationChoice: {},
  prepareEncryptionResult: null
}

const per = (state = initialData, action = {}) => {
  const { payload, responseHeaders } = action
  switch (action.type) {
    case PerTypes.GET_PERS_SUCCESS:
      return {
        ...state,
        list: payload?.pers?.items,
        pagination: payload?.pers?.meta
      }
    case PerTypes.GET_PER_DETAIL_SUCCESS:
      return { ...state, current: payload?.pers }
    case PerTypes.UPDATE_FILTER_PER_SUCCESS:
      return { ...state, filter: payload }
    case PerTypes.GET_SYSTEM_PERS_SUCCESS:
      return { ...state, systems: payload?.pers?.items }
    case PerTypes.GET_PER_ALERTS_SUCCESS:
      return {
        ...state,
        alert: {
          ...state.alert,
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case PerTypes.GET_PER_PACKAGE_LOGS_SUCCESS:
      return {
        ...state,
        packageLog: {
          ...state.packageLog,
          list: payload?.persPackageLog?.items,
          pagination: payload?.persPackageLog?.meta
        }
      }
    case PerTypes.GET_VEHICLE_TRIPS_SUCCESS:
      return {
        ...state,
        vehicleTrip: {
          ...state.vehicleTrip,
          list: payload?.items,
          pagination: payload?.meta
        }
      }
    case PerTypes.GET_VEHICLE_TRIP_DETAIL_SUCCESS:
      return {
        ...state,
        vehicleTrip: {
          ...state.vehicleTrip,
          current: payload
        }
      }
    case PerTypes.EXPORT_VEHICLE_TRIP_DETAIL_SUCCESS:
      return {
        ...state,
        vehicleTrip: {
          ...state.vehicleTrip,
          exportData: {
            data: payload,
            responseHeaders
          }
        }
      }
    case PerTypes.GET_PER_CURRENT_DATA_SUCCESS:
      return { ...state, currentData: payload }
    case PerTypes.GET_COMPANY_PERS_LINKED_SUCCESS:
      return { ...state, companyPersLinked: payload?.items }
    case PerTypes.GET_PERS_KIT_CONFIGURATION_SUCCESS:
      return {
        ...state,
        persKitConfiguration: payload?.persKitConfiguration
      }
    case PerTypes.GET_MQTT_MESSAGE_LOGS_SUCCESS:
      if (payload?.meta?.currentPage === 1) {
        return {
          ...state,
          mqttMessageLog: {
            list: payload?.items,
            pagination: payload?.meta
          }
        }
      }
      return {
        ...state,
        mqttMessageLog: {
          list: [
            ...(state.mqttMessageLog.list || []),
            ...(payload?.items || [])
          ],
          pagination: payload?.meta
        }
      }
    case PerTypes.GET_DOWNLOADABLE_FIRMWARE_VERSIONS_SUCCESS:
      return {
        ...state,
        downloadableFirmwareVersions: payload?.firmwareVersions || []
      }
    case PerTypes.GET_DOWNLOADABLE_KIT_CONFIGURATION_VERSIONS_SUCCESS:
      return {
        ...state,
        downloadableKitConfigurationVersions:
          payload?.kitConfigurationVersions || [],
        downloadableKitConfigurationChoice: {
          downloadableStorageKinds: payload?.downloadableStorageKinds,
          recommendedStorageKind: payload?.recommendedStorageKind,
          persFirmwareVersion: payload?.persFirmwareVersion
        }
      }
    case PerTypes.PREPARE_ENCRYPTION_SUCCESS:
      return {
        ...state,
        prepareEncryptionResult: payload || null
      }
    case UserTypes.LOGOUT_SUCCESS:
      return initialData

    default:
      return state
  }
}

export default per
